import React from "react";
import HashLoader from "react-spinners/HashLoader";
import useThemeColor from "../../../hooks/useThemeColor";
import "./GridSectionLoader.css";

/**
 * Loading overlay scoped to a content region (e.g. filters + grid).
 * Parent sets position context; when loading is true, a minimum height is applied so the overlay is visible even if children render empty.
 */
const GridSectionLoader = ({
  loading,
  children,
  className = "",
  minHeight = "240px",
  message = "",
}) => {
  const themeColor = useThemeColor();

  return (
    <div
      className={`grid-section-loader ${className}`.trim()}
      style={{
        position: "relative",
        ...(loading ? { minHeight } : {}),
      }}
      aria-busy={loading}
    >
      {children}
      {loading && (
        <div className="grid-section-loader__overlay" role="status" aria-live="polite">
          <div className="grid-section-loader__panel">
            <HashLoader color={themeColor} size={48} />
            {message ? (
              <p className="grid-section-loader__message mb-0">{message}</p>
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
};

export default GridSectionLoader;
